import {gsap, ScrollTrigger} from "../LibrariesImport";
import DevHelpers from "../utils/DevHelpers";

export default class BlockListTextImage {
    static init() {
        this.blocks = document.querySelectorAll(".block-list-text-image");

        if (this.blocks.length < 1) {
            return;
        }

        this.blocks.forEach(block => {
            this.reveal(block);
        });
    }

    static reveal(block) {
        const lines = block.querySelectorAll(".line");

        lines.forEach((line, index) => {
            gsap.set(line, { autoAlpha: 0, y: 50, willChange: "transform" });

            gsap.to(line, {
                autoAlpha: 1,
                y: 0,
                duration: 0.5,
                scrollTrigger: {
                    trigger: line,
                    start: "top 90%",
                    end: "bottom 80%",
                    scrub: true
                }
            });

            /*gsap.set(line.querySelector(".rich-text"), { autoAlpha: 0, y: 100, willChange: "transform" });
            gsap.to(line.querySelector(".rich-text"), {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                scrollTrigger: {
                    trigger: line,
                    start: "top 95%",
                    end: "bottom 80%",
                    scrub: true
                }
            });*/
        });
    }
}